'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../../../tslib.es6-CZ43up4V.js');
const jsxRuntime = require('react/jsx-runtime');
const components_display_Icon_Icon = require('../Icon/Icon.cjs.js');

const root = "_root_1ps44_1";
const container = "_container_1ps44_70";
const statusIcon = "_status-icon_1ps44_75";
const title = "_title_1ps44_102";
const closeButton = "_close-button_1ps44_113";
const styles = {
	root: root,
	container: container,
	statusIcon: statusIcon,
	title: title,
	closeButton: closeButton
};

const STATUS_ICONS = {
  info: "alertInfoFill",
  success: "formCheckCircle",
  warning: "alertCircleColor",
  error: "formXCircle"
};
const Alert = (_a) => {
  var { children = void 0, onDismiss = void 0, role = void 0, status = "info", title = void 0, variant = "alert" } = _a, props = tslib_es6.__rest(_a, ["children", "onDismiss", "role", "status", "title", "variant"]);
  const closeButton = onDismiss && jsxRuntime.jsx("button", { type: "button", "aria-label": "Dismiss", className: styles.closeButton, onClick: onDismiss, "data-zds": true, children: jsxRuntime.jsx(components_display_Icon_Icon.Icon, { isBlock: true, name: "formX", size: 24 }) });
  return jsxRuntime.jsxs("article", { "aria-live": props["aria-live"], className: styles.root, "data-status": status, role, "data-variant": variant, "data-zds": true, children: [jsxRuntime.jsx("div", { className: styles.statusIcon, "data-status": status, "data-variant": variant, "data-zds": true, children: jsxRuntime.jsx(components_display_Icon_Icon.Icon, { "aria-label": status, isBlock: true, name: STATUS_ICONS[status] || "alertInfoFill", size: variant === "compact" ? 20 : 24 }) }), jsxRuntime.jsxs("div", { className: styles.container, "data-zds": true, children: [title && jsxRuntime.jsx("h2", { className: styles.title, "data-variant": variant, "data-zds": true, children: title }), children] }), closeButton] });
};

exports.Alert = Alert;
//# sourceMappingURL=Alert.cjs.js.map
